import { h } from 'preact';
import Unread from 'widget_main/components/Unread';
import ChatIcon from 'widget_main/components/ChatIcon';
import styles from './chatRootIcon.scss';

interface ChatRootIconProps {
  onClick?: () => void;
}

const ChatRootIcon = ({ onClick }: ChatRootIconProps) => {
  return (
    <div className={styles.wrapper}>
      <ChatIcon isEmbedIcon onClick={onClick} />
      <Unread className={styles.unreadProp} />
    </div>
  );
};
export default ChatRootIcon;
